import dayjs from "dayjs";
import { useEffect, useState } from "react";

const duration = require("dayjs/plugin/duration");
dayjs.extend(duration);

export const useCountdown = ({
  time,
  shorten,
  allowCountdown = true,
  intervalCount = 1000,
}) => {
  const [countdown, setCountdown] = useState(null);

  // Sets initial time to avoids interval delay
  useEffect(() => {
    if (!allowCountdown) return;
    setCountdown(getCountdown(time, shorten));
  }, [time, shorten, allowCountdown]);

  useEffect(() => {
    if (!allowCountdown) return;
    const interval = setInterval(() => {
      setCountdown(getCountdown(time, shorten));
    }, intervalCount);
    return () => clearInterval(interval);
  }, [time, shorten, allowCountdown, intervalCount]);

  const getCountdown = (time, shorten) => {
    const currentTime = dayjs();
    const eventTime = dayjs(time);

    const interval = 1000;
    let duration = dayjs.duration(eventTime.diff(currentTime));
    let text = "";

    // get updated duration
    duration = dayjs.duration(duration - interval, "milliseconds");

    // if duration is >= 0
    if (duration.asSeconds() <= 0) {
      text = "";
    } else {
      // otherwise, show the updated countdown
      if (duration.days()) {
        text += duration.days() + `${shorten ? "d" : " days"} `;
      }
      if (duration.hours()) {
        text += duration.hours() + `${shorten ? "h" : " hours"} `;
      }
      if (duration.minutes()) {
        text += duration.minutes() + `${shorten ? "m" : " minutes"} `;
      }
      if (duration.seconds()) {
        text += duration.seconds() + `${shorten ? "s" : " seconds"}`;
      }
    }
    return text;
  };

  return countdown;
};
